import React from 'react';
import { getModelState } from 'client/data/luckdragon/model';
import { ModelPreloader } from 'client/data/luckdragon/redux/model-preloader';
import { CmsModel } from 'client/data/models/cms';
import { RESEARCH_SUBNAV_CONTENT_PATH } from 'client/data/constants/contents-paths';
import { pageDefinition } from 'site-modules/shared/pages/page';
import { getBreadcrumbSchema } from 'client/seo/schemas/breadcrumbs';
import { parseContent } from 'client/data/cms/content';
import { handle404Error } from 'site-modules/shared/utils/errors';
import { getMeta } from 'site-modules/shared/utils/seo-helper';
import {
  getIndustryCenterArticleBreadcrumbs,
  getIndustryCenterArticleContentPath,
} from 'site-modules/industry-center/utils/industry-center-article';
import { INDUSTRY_CENTER_ARTICLE_RIGHT_RAIL_CONTENT } from 'site-modules/industry-center/constants/industry-center-article';
import { IndustryCenterArticle } from './industry-center-article';

export const getPageOptions = ({ articleCategory, articleId }) => ({
  name: `car_news_industry_${articleCategory}_article`,
  category: 'car_news',
  preload: store => {
    const preloader = new ModelPreloader(store);
    const articlePath = getIndustryCenterArticleContentPath({ articleCategory, articleId });

    preloader.resolve(`content["${articlePath}.withContent"]`, CmsModel);

    const rightRailContentPath = INDUSTRY_CENTER_ARTICLE_RIGHT_RAIL_CONTENT[articleCategory];
    if (rightRailContentPath) {
      preloader.resolve(`content["${rightRailContentPath}.withContent"]`, CmsModel);
    } else {
      preloader.resolve(`content["${RESEARCH_SUBNAV_CONTENT_PATH}"]`, CmsModel);
    }

    return preloader.load().then(modelState => {
      const article = modelState.get(`content["${articlePath}.withContent"]`, CmsModel);

      if (!(article && article.id)) {
        throw handle404Error({ errorMessage: `No content was found for ${articlePath}` });
      }

      return preloader.load();
    });
  },
  seo: state => {
    const modelState = getModelState(state);
    const articlePath = getIndustryCenterArticleContentPath({ articleCategory, articleId });
    const content = parseContent(modelState.get(`content["${articlePath}.withContent"]`, CmsModel));

    return {
      ...getMeta(content),
      jsonld: [
        getBreadcrumbSchema(getIndustryCenterArticleBreadcrumbs({ articleCategory, articleId, title: content.title })),
      ],
    };
  },
  component: () => <IndustryCenterArticle articleId={articleId} articleCategory={articleCategory} />,
});

export default params => pageDefinition(getPageOptions(params));
